export enum MeterElectricalFieldName {
  phase = 'phase',
  interval = 'interval',
  metric = 'metric',
  aggregation = 'aggregation'
}

export enum ElectricalChartFilterType {
  DateTimeUTC = 'DateTimeUTC',
  Phase = 'Phase',
  DeviceUID = 'DeviceUID',
  MetaDataQualityCode = 'MetaDataQualityCode',
  Accumulation = 'Accumulation',
  Kind = 'Kind',
  Aggregate = 'Aggregate',
  IsVisualized = 'IsVisualized',
  MeasuringPeriod = 'MeasuringPeriod'
}

export const ELECTRICAL_FIELD_TO_FILTER_TYPE: Record<string, ElectricalChartFilterType> = {
  [MeterElectricalFieldName.metric]: ElectricalChartFilterType.Kind,
  [MeterElectricalFieldName.interval]: ElectricalChartFilterType.MeasuringPeriod,
  [MeterElectricalFieldName.phase]: ElectricalChartFilterType.Phase,
  [MeterElectricalFieldName.aggregation]: ElectricalChartFilterType.Aggregate
};

export interface ChartDataPoint {
  date: string;
  aggregate: string;
  phase: string;
  unitOfMeasure: string;
  multiplier: string;
  value: number;
}

export interface GetChartDataFilter {
  filterType: ElectricalChartFilterType;
  filteredValues: string[];
}

export interface GetChartDataPayload {
  filters: GetChartDataFilter[];
}

export interface GetChartDataResponse {
  current: ChartDataPoint[];
  voltage: ChartDataPoint[];
}

export interface GetFiltersPayload {
  deviceUID: string;
  startDateUtc: string;
  endDateUtc: string;
}

export interface GetFiltersResponse {
  kinds: string[] | null;
  measuringPeriods: string[] | null;
  phases: string[] | null;
  aggregations: string[] | null;
}

export interface TableMetric {
  kind: string;
  phase: string;
  aggregate: string;
  value: number;
  multiplier: string | null;
  unitOfMeasure: string;
}

export interface TableDataItem {
  dateTime: string;
  metrics: TableMetric[];
}

export interface GetTableDataSort {
  columnName: string;
  orderDirection: 'ASC' | 'DESC';
}

export interface GetTableDataPayload {
  filters: GetChartDataFilter[];
  sort: GetTableDataSort;
  skip: number;
  take: number;
}

export interface GetTableDataResponse {
  items: TableDataItem[];
  totalCount: number;
}

export interface ElectricalTableColumnDef {
  key: string;
  title: string;
  csvTitle: string;
}

export type ElectricalTableRow = Record<string, string | number | null>;

export interface ElectricalTableData {
  columnDefs: ElectricalTableColumnDef[];
  data: ElectricalTableRow[];
  total: number;
}
